import React, { Component, Fragment } from 'react'
import injectSheet from 'react-jss'
import styles from './school-data.styles'
import Paper from 'pobble-components/dist/paper'
import Spinner from 'pobble-components/dist/spinner'
import SchoolImport from './school-import/school-import.container'

class SchoolData extends Component {
  componentDidMount() {
    this.props.onMount()
  }
  render() {
    const { classes, pending } = this.props
    return (
      <Fragment>
        {!pending && (
          <Paper className={classes.container}>
            <SchoolImport />
          </Paper>
        )}
        {pending && <Spinner className={classes.spinner} />}
      </Fragment>
    )
  }
}

export default injectSheet(styles)(SchoolData)
